// domain translations
import spanishMessages from 'aor-language-spanish'
import { createBrowserHistory as createHistory } from 'history'
import danishMessages from 'ra-language-danish'
import dutchMessages from 'ra-language-dutch'
import englishMessages from 'ra-language-english'
import frenchMessages from 'ra-language-french'
import italianMessages from 'ra-language-italian'
import romanianMessages from 'ra-language-romanian'
import treeEnglishMessages from 'ra-tree-language-english'
import treeFrenchMessages from 'ra-tree-language-french'
import { reducer as tree } from 'ra-tree-ui-materialui'
import React, { Component } from 'react'
import { Admin, mergeTranslations, Resource } from 'react-admin'
import './App.css'
import assetCustomFields from './asset-custom-fields'
import assetStatus from './asset-status'
import assetTypes from './asset-types'
import Login from './auth/Login'
import authProvider from './authProvider'
import branding from './branding'
import categories from './categories'
import customRoutes from './customRoutes'
import dataProvider from './dataProvider'
import * as owndics from './dic'
import invitations from './invitations'
import MyLayout from './MyLayout'
import priorities from './priorities'
import users from './users'

const history = createHistory()

const messages = {
  nl: mergeTranslations(dutchMessages, owndics.nl),
  en: mergeTranslations(englishMessages, treeEnglishMessages, owndics.en),
  es: mergeTranslations(spanishMessages, owndics.es),
  fr: mergeTranslations(frenchMessages, treeFrenchMessages, owndics.fr),
  it: mergeTranslations(italianMessages, owndics.it),
  da: mergeTranslations(danishMessages, owndics.da),
  ro: mergeTranslations(romanianMessages, owndics.ro),
  no: mergeTranslations(englishMessages, owndics.no),
  de: mergeTranslations(englishMessages, owndics.de),
}

const i18nProvider = (locale) => messages[locale]

class App extends Component {
  render() {
    return (
      <Admin
        locale="en"
        i18nProvider={i18nProvider}
        loginPage={Login}
        customReducers={{ tree }}
        customRoutes={customRoutes}
        appLayout={MyLayout}
        history={history}
        dataProvider={dataProvider}
        authProvider={authProvider(history)}
      >
        {async (permissions) => {
          return [
            ...(permissions && permissions.includes('read:users')
              ? [
                  <Resource {...users(permissions)} />,
                  <Resource {...invitations(permissions)} />,
                  <Resource name="roles" />,
                ]
              : []),

            ...(permissions && permissions.includes('read:categories')
              ? [<Resource {...categories(permissions)} />]
              : []),
            ...(permissions && permissions.includes('update:priorities')
              ? [<Resource {...priorities(permissions)} />]
              : []),
            ...(permissions && permissions.includes('update:branding')
              ? [<Resource {...branding(permissions)} />]
              : []),
            ...(permissions && permissions.includes('read:assets')
              ? [
                  <Resource {...assetTypes(permissions)} />,
                  <Resource {...assetStatus(permissions)} />,
                  <Resource {...assetCustomFields(permissions)} />,
                ]
              : []),
            <Resource name="meta" />,
          ]
        }}
      </Admin>
    )
  }
}

export default App
